import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Conversational Agents", desc: "Website bots · WhatsApp business bots · Instagram DM automation · Telegram bots · Internal helpdesk bots" },
  { title: "Task Execution Agents", desc: "Web scraping & data compilation · Form-filling agents · Dashboard monitoring · Document routing · Lead generation pipeline" },
  { title: "Agentic Workflows", desc: "Client onboarding pipeline · Support ticket resolution · Sales pipeline automation · Invoice-to-payment tracking · Content pipeline" },
  { title: "Key Distinction", desc: "A chatbot answers questions. An AI agent takes actions." },
];

const AiAgents = () => (
  <StitchFeaturePage
    label="SERVICE · AI AGENTS & AUTOMATION"
    title="Agents that"
    titleAccent="act, not just chat."
    subtitle="Beyond chatbots. AI agents that browse the web, fill forms, update your CRM, send emails, and run entire workflows — without a human in the loop."
    features={features}
    badges={["LangChain", "LangGraph", "AutoGen", "CrewAI", "Custom Python", "n8n", "Flowise", "Zapier/Make"]}
    ctaLabel="BUILD YOUR AI AGENT"
  >
    </StitchFeaturePage>
);

export default AiAgents;
